import RadioButtonGroupComponent from './radio-button-group.component'

const RadioButtonGroupModule = angular.module('cdbl.form.radio-button-group', [

])
  .component('cdblRadioButtonGroup', RadioButtonGroupComponent)
  .name

export default RadioButtonGroupModule
